import gsap from 'gsap'
import { reduceMotion } from '@js/animations/ReducedMotion'

export class Shape {
  constructor () {
    this.elements = document.querySelectorAll('[animation-shape]')

    if (!this.elements.length) {
      return
    }

    this.init()
  }

  init () {
    this.elements.forEach((el) => {
      if (reduceMotion) {
        gsap.set(el, { scale: 1 })
        return
      }

      gsap.fromTo(
        el,
        { scale: 0 },
        {
          scale: 1,
          duration: 1,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: el,
            start: 'top 90%',
            toggleActions: 'play none none none',
          },
        }
      )
    })
  }
}
